package com.xtream.composeapp.presentation.widget

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.DialogProperties
import coil3.PlatformContext
import coil3.compose.LocalPlatformContext
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.platform.openBrowser
import com.xtream.composeapp.platform.openEmail
import com.xtream.composeapp.platform.openTelegram
import com.xtream.composeapp.platform.openWhatsApp
import com.xtream.sharedResources.resources.E_Mail
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.close
import com.xtream.sharedResources.resources.confirm_opening_in_browser
import com.xtream.sharedResources.resources.mail
import com.xtream.sharedResources.resources.qr_code
import com.xtream.sharedResources.resources.scan_me
import com.xtream.sharedResources.resources.support_1
import com.xtream.sharedResources.resources.support_2
import com.xtream.sharedResources.resources.support_contact
import com.xtream.sharedResources.resources.telegram
import com.xtream.sharedResources.resources.website
import com.xtream.sharedResources.resources.whatsapp
import com.xtream.sharedResources.resources.www
import com.xtream.ui.platform.adaptiveValue
import com.xtream.ui.ui.widget.TvButton
import com.xtream.ui.ui.widget.XtreamActionDialog
import io.github.alexzhirkevich.qrose.options.QrBallShape
import io.github.alexzhirkevich.qrose.options.QrBrush
import io.github.alexzhirkevich.qrose.options.QrFrameShape
import io.github.alexzhirkevich.qrose.options.QrLogoPadding
import io.github.alexzhirkevich.qrose.options.QrLogoShape
import io.github.alexzhirkevich.qrose.options.QrPixelShape
import io.github.alexzhirkevich.qrose.options.brush
import io.github.alexzhirkevich.qrose.options.circle
import io.github.alexzhirkevich.qrose.options.roundCorners
import io.github.alexzhirkevich.qrose.options.solid
import io.github.alexzhirkevich.qrose.rememberQrCodePainter
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

data class ContactInfoItem(
     val key: String = "",
     val icon: ImageVector? = null,
     val title: StringResource,
     val description: String? = null,
    val url: String = "",        // ✅ replaces intentAction — used for QR + intent
    val onClick: () -> Unit,
)
@Composable
fun ContactInfoDialog(show: Boolean = true, onDismiss: () -> Unit = {}) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    //val errorMessage = stringResource(Res.string.activity_open_fail)

        var showConfirmationDialog: Boolean  by remember { mutableStateOf(false) }

        var onConfirm by remember { mutableStateOf<(() -> Unit)?>(null) }
        val showQRCode = adaptiveValue(expandedValue = true, compactValue = false, default = false)
    // ── All string resources resolved once, at the top ──────────────────────
    val support1        = SharedBuildKonfig.SUPPORT_WHATSAPP
    val support2        = SharedBuildKonfig.SUPPORT_WHATSAPP2
    val telegramAddress = SharedBuildKonfig.SUPPORT_TELEGRAM  // e.g. "t.me/inTv_Plus"
    val emailAddress    = SharedBuildKonfig.SUPPORT_EMAIL
    val domainAddress   = SharedBuildKonfig.DOMAIN_ADDRESS

if(showConfirmationDialog)
            XtreamActionDialog(
                titleText = "Confirmation",
                positiveButtonText = "Proceed anyway",
                negativeButtonText = "Cancel",
                showNegativeButton = true,
                onDismiss = {
                    showConfirmationDialog = false
                },
                onPositiveButtonClick = {
                    //try {
                        onConfirm?.invoke()
                   // } catch (e: Exception) {
                       //TODO Toast.makeText(requireActivity, errorMessage, Toast.LENGTH_SHORT).show()
                    //}
                    showConfirmationDialog = false



                },
                onNegativeButtonClick = {
                    showConfirmationDialog = false

                }
            ){
                Text(stringResource(Res.string.confirm_opening_in_browser))
            }


    fun runApp( app:()-> Unit){
       onConfirm= { app.invoke() }
        showConfirmationDialog= true
    }




val context: PlatformContext = LocalPlatformContext.current

        if(show)
        XtreamActionDialog(
            titleText = stringResource( Res.string.support_contact),
          positiveButtonText = stringResource( Res.string.close),
            showNegativeButton = false,
            showPositiveButton = !showQRCode,
            onDismiss = {
                onDismiss()
            },
            properties = DialogProperties(

                usePlatformDefaultWidth = !showQRCode
                ),
            onPositiveButtonClick = {
                onDismiss()
            }
        ) {


// support1 / support2 no longer declared here — already available above

            val listActions = buildList {
                add(
                    ContactInfoItem(
                        title = Res.string.support_1,
                        description = support1,
                        icon = vectorResource(Res.drawable.whatsapp),
                        onClick = {
                            runApp{
                                openWhatsApp(support1.replace(" ", ""), context)
                            } }
                    ),

                )
                if(support2.isNotEmpty())
                add(
                    ContactInfoItem(
                        title = Res.string.support_2,
                        description = support2,
                        icon = vectorResource(Res.drawable.whatsapp),
                        url = "https://wa.me/${support2.replace(" ", "")}",
                        onClick = {
                            runApp{ openWhatsApp(support2.replace(" ", ""), context)}
                        }
                    )
                )
                addAll(listOf(

                    ContactInfoItem(
                        title = Res.string.telegram,
                        description = telegramAddress,
                        icon = vectorResource(Res.drawable.telegram),
                        url = "https://$telegramAddress",               // ← was .plus(R.string.*)
                        onClick = {
                            runApp{openTelegram(telegramAddress, context)}
                        }
                    ),
                    ContactInfoItem(
                        title = Res.string.E_Mail,
                        description = emailAddress,
                        icon = vectorResource(Res.drawable.mail),
                        url = "mailto:$emailAddress",                   // ← was .plus(R.string.*)
                        onClick = {
                            runApp{openEmail(emailAddress, context)}
                        }
                    ),
                    ContactInfoItem(
                        title = Res.string.website,
                        description = domainAddress,
                        icon = vectorResource(Res.drawable.www),
                        url = "https://$domainAddress",                 // ← was .plus(R.string.*)
                        onClick = {
                            runApp{ openBrowser(domainAddress, context)}
                        }
                    )
                ))
            }


            var qrDataState by remember {
                mutableStateOf("")
            }

            val defaultLogo = painterResource(brandLogoResource())
            var qrLogo: Painter? by remember {
                mutableStateOf(defaultLogo)
            }

            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {

                if(showQRCode){
                    Column(
                        modifier = Modifier
                            .weight(.25f)
                            .wrapContentHeight(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ){
                        Image(
                            modifier = Modifier

                                .aspectRatio(1f)
                                .padding(48.dp),
                            painter = rememberQrCodePainter(qrDataState,qrLogo),
                            contentDescription = stringResource(Res.string.qr_code)
                        )
                        Text(
                            text = stringResource(Res.string.scan_me),
                            fontWeight = FontWeight.ExtraBold,
                            style = MaterialTheme.typography.headlineMedium


                        )
                    }
                    VerticalDivider(
                        color = MaterialTheme.colorScheme.onSurface.copy(
                            alpha = 0.12f
                        ),
                        thickness = 1.dp,
                        modifier = Modifier
                            .width(2.dp)
                            .fillMaxHeight()
                            .padding(8.dp)
                    )
                }
                val focusRequester = remember { FocusRequester() }

                LazyColumn(
                    modifier = Modifier.weight(.4f).focusRestorer(focusRequester),

                    contentPadding = PaddingValues( horizontal = if (showQRCode) 48.dp else 16.dp, vertical = 16.dp),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    items( listActions.size, key = { listActions[it].let {it.toString()+ it.title+"_"+ it.key}}) {index->
                        val item = listActions.getOrNull(index)
                        val logo = item?.icon?.let {
                            rememberVectorPainter(it)
                        }
                        TvButton(
                            modifier = Modifier


                                .onFocusChanged {
                                    if (it.hasFocus) {
                                        qrDataState = item?.url ?: ""
                                        qrLogo = logo
                                    }
                                }
                                .then(
                                    if (index==0)
                                    Modifier                                .focusRequester(focusRequester)
                                    else Modifier

                            ),
                            title = item?.title?.let { stringResource(it) }?:"",
                            subtitle = item?.description?.replace(" ",""),
                            useIconTint = false,
                            fillParent = true,
                            contentPadding = PaddingValues(start=3.dp),
                            leadingIcon =logo,
                            startContentScale = ContentScale.Fit,
                        onClick = item?.onClick?:{}
                        )
                    }
                    /*item {
                        TvButton(
                            modifier = Modifier

                                .fillMaxWidth()
                                .focusRequester(focusRequester),
                            title = stringResource(R.string.support_1),
                            subtitle = stringResource(R.string.support_whatsapp).replace(" ",""),
                            useIconTint = false,
                            leadingIcon = painterResource(R.drawable.whatsapp)
                        ) {

                            openWhatsApp(
                                support1.replace(" ","")
                            )
                        }
                    }

                    item {

                        TvButton(
                            modifier = Modifier.fillMaxWidth(),

                            title = stringResource(R.string.support_2),
                            subtitle = stringResource(R.string.support_whatsapp2).replace(" ",""),
                            useIconTint = false,

                            leadingIcon = painterResource(R.drawable.whatsapp)
                        ) { openWhatsApp(support2.replace(" ","")) }
                    }
                    item {
                        TvButton(
                            modifier = Modifier.fillMaxWidth(),
                            title = stringResource(R.string.telegram),
                            subtitle = stringResource(R.string.support_telegram),
                            useIconTint = false,
                            leadingIcon = painterResource(R.drawable.telegram)
                        ) {
                            openTelegram()
                        }
                    }
                    item {

                        TvButton(
                            modifier = Modifier.fillMaxWidth(),

                            title = stringResource(R.string.E_Mail),
                            subtitle = stringResource(R.string.support_email),
                            useIconTint = false,

                            leadingIcon = painterResource(R.drawable.mail)
                        ) { openEmail() }
                    }
                    item {

                        TvButton(
                            modifier = Modifier.fillMaxWidth(),

                            title = stringResource(R.string.website),
                            subtitle = stringResource(R.string.domain_address),
                            useIconTint = false,

                            leadingIcon = painterResource(R.drawable.www)
                        ) { openBrowser() }
                    }*/

                }
            }

        }
    }


@Composable
fun rememberQrCodePainter(data: String, logoPainter: Painter? = null): Painter{

    return  rememberQrCodePainter(data) {
        logo {
            painter = logoPainter
            padding = QrLogoPadding.Natural(.1f)
            shape = QrLogoShape.circle()
            size = 0.2f
        }

        shapes {
            ball = QrBallShape.circle()
            darkPixel = QrPixelShape.roundCorners()
            frame = QrFrameShape.roundCorners(.25f)
        }
        colors {
            dark = QrBrush.brush {
                Brush.linearGradient(
                    0f to Color.Red,
                    1f to Color.Blue,
                    end = Offset(it, it)
                )
            }
            frame = QrBrush.solid(Color.White)
        }
    }
}


